import React, { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AssessmentPage from "../pages/assessment/page";
import HakkimizdaPage from "../pages/hakkimizda/page";

// Lazy load service pages
const MilliTGBPage = React.lazy(() => import("../pages/hizmetler/milli-tgb/page"));
const NatoTGBPage = React.lazy(() => import("../pages/hizmetler/nato-tgb/page"));
const OzelTGBPage = React.lazy(() => import("../pages/hizmetler/ozel-tgb/page"));
const BelgeYenilemePage = React.lazy(() => import("../pages/hizmetler/belge-yenileme/page"));
const FizikiGuvenlikPage = React.lazy(() => import("../pages/hizmetler/fiziki-guvenlik/page"));
const PersonelGuvenlikPage = React.lazy(() => import("../pages/hizmetler/personel-guvenlik-sorusturmasi/page"));

// Lazy load blog pages
const BlogPage = React.lazy(() => import("../pages/blog/page"));
const TesisGuvenlikBelgesiNedirPage = React.lazy(() => import("../pages/blog/tesis-guvenlik-belgesi-nedir/page"));
const MsbBasvuruSureciPage = React.lazy(() => import("../pages/blog/msb-basvuru-sureci/page"));
const NatoTgbMilliTgbFarklariPage = React.lazy(() => import("../pages/blog/nato-tgb-milli-tgb-farklari/page"));
const FizikiGuvenlikGereksinimPage = React.lazy(() => import("../pages/blog/fiziki-guvenlik-gereksinimleri/page"));
const PersonelGuvenlikSorusturmasiPage = React.lazy(() => import("../pages/blog/personel-guvenlik-sorusturmasi/page"));
const TgbDanismanlikFirmasiSecimiPage = React.lazy(() => import("../pages/blog/tgb-danismanlik-firmasi-secimi/page"));

// Lazy load legal pages
const GizlilikPolitikasiPage = lazy(() => import('../pages/gizlilik-politikasi/page'));
const KullanimKosullariPage = lazy(() => import('../pages/kullanim-kosullari/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const IletisimPage = lazy(() => import('../pages/iletisim/page'));
const HizmetlerPage = lazy(() => import('../pages/hizmetler/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ucretsiz-on-degerlendirme",
    element: <AssessmentPage />,
  },
  {
    path: "/hizmetler",
    element: (
      <React.Suspense fallback={<div>Yükleniyor...</div>}>
        <HizmetlerPage />
      </React.Suspense>
    ),
  },
  {
    path: "/hizmetler/milli-tgb",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><MilliTGBPage /></React.Suspense>,
  },
  {
    path: "/hizmetler/nato-tgb",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><NatoTGBPage /></React.Suspense>,
  },
  {
    path: "/hizmetler/ozel-tgb",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><OzelTGBPage /></React.Suspense>,
  },
  {
    path: "/hizmetler/belge-yenileme",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><BelgeYenilemePage /></React.Suspense>,
  },
  {
    path: "/hizmetler/fiziki-guvenlik",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><FizikiGuvenlikPage /></React.Suspense>,
  },
  {
    path: "/hizmetler/personel-guvenlik-sorusturmasi",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><PersonelGuvenlikPage /></React.Suspense>,
  },
  {
    path: "/blog",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><BlogPage /></React.Suspense>,
  },
  {
    path: "/blog/tesis-guvenlik-belgesi-nedir",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><TesisGuvenlikBelgesiNedirPage /></React.Suspense>,
  },
  {
    path: "/blog/msb-basvuru-sureci",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><MsbBasvuruSureciPage /></React.Suspense>,
  },
  {
    path: "/blog/nato-tgb-milli-tgb-farklari",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><NatoTgbMilliTgbFarklariPage /></React.Suspense>,
  },
  {
    path: "/blog/fiziki-guvenlik-gereksinimleri",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><FizikiGuvenlikGereksinimPage /></React.Suspense>,
  },
  {
    path: "/blog/personel-guvenlik-sorusturmasi",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><PersonelGuvenlikSorusturmasiPage /></React.Suspense>,
  },
  {
    path: "/blog/tgb-danismanlik-firmasi-secimi",
    element: <React.Suspense fallback={<div>Yükleniyor...</div>}><TgbDanismanlikFirmasiSecimiPage /></React.Suspense>,
  },
  {
    path: "/gizlilik-politikasi",
    element: (
      <React.Suspense fallback={<div>Yükleniyor...</div>}>
        <GizlilikPolitikasiPage />
      </React.Suspense>
    ),
  },
  {
    path: "/kullanim-kosullari",
    element: (
      <React.Suspense fallback={<div>Yükleniyor...</div>}>
        <KullanimKosullariPage />
      </React.Suspense>
    ),
  },
  {
    path: "/kvkk",
    element: (
      <React.Suspense fallback={<div>Yükleniyor...</div>}>
        <KVKKPage />
      </React.Suspense>
    ),
  },
  {
    path: "/iletisim",
    element: (
      <React.Suspense fallback={<div>Yükleniyor...</div>}>
        <IletisimPage />
      </React.Suspense>
    ),
  },
  {
    path: "/hakkimizda",
    element: <HakkimizdaPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
